export default __webpack_public_path__ + "book_details-fiona_pages.5705214c.png";